module.exports = __webpack_public_path__ + "static/img/manual_ja_30.1c7feed.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ja/manual_ja_30.png
// module id = 4PgS
// module chunks = 4